module.exports = __webpack_public_path__ + "media/ringtone.dd3b78e1.mp3";